import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { DialogTitle, Dialog, DialogActions, DialogContent, DialogContentText } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdAdd, MdAddCircle, MdAddCircleOutline, MdApproval, MdArrowBack, MdArrowRightAlt, MdCheckCircle, MdClass, MdDone, MdEmail, MdFactCheck, MdInbox, MdInsertInvitation, MdLockClock, MdMail, MdMarkunreadMailbox, MdOutlineApproval, MdOutlineSettingsSuggest, MdPassword, MdPendingActions, MdRememberMe, MdResetTv, MdRocket, MdSchool, MdSend, MdSettings, MdSettingsAccessibility, MdStorage, MdTimelapse, MdTimer, MdTimer10 } from "react-icons/md";
import { Commet } from "react-loading-indicators";
import { useNavigate } from "react-router-dom";
import { Button } from "rsuite";
import { web_url } from "../../constant";
import axios from "axios";
import * as XLSX from "xlsx";


function ResearcherInvite() {
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    const [userDetail, setuserDetail] = useState({
        email: '',
        role: ''
    })

    const [error, setError] = useState({
        invalidEmail: false,
        noEmail: false,
        noRole: false,
    })

    const [openError, setOpenError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setErrorMsg(t('t93'));
            // console.log("1");

        } else if (err.toLowerCase().includes('found')) {
            setErrorMsg(t('t414'));
            // console.log("2");
        } else if (err.toLowerCase().includes('already mail is there')) {
            setErrorMsg(t('t414'));
            // console.log("2");
        } else if (err.toLowerCase().includes('already sent')) {
            setErrorMsg(t('t259'));
            // console.log("2");
        } else {
            setErrorMsg(t('t94'));
            // console.log("3");
        }
        setIsLoading(false);
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
        setuserDetail(() => ({ email: "", role: "" }))
    };

    const [open1, setOpen1] = useState(false);

    const handleClickOpen1 = () => {
        setOpen1(true);
    };

    const handleClose1 = () => {
        setOpen1(false);
    };

    const [openAlert, setOpenAlert] = useState(false);

    const handleClickOpenAlert = () => {
        setOpenAlert(true);
    };

    const handleCloseAlert = () => {
        setOpenAlert(false);
    };

    const handleButtonClick = () => {

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        let newErrors = {};

        newErrors.noEmail = !userDetail.email;
        newErrors.noRole = !userDetail.role;

        if ((userDetail.email) && !emailRegex.test(userDetail.email)) {
            newErrors.invalidEmail = true;
        } else {
            newErrors.invalidEmail = false;
        }

        setError(newErrors);

        if (Object.values(newErrors).some((error) => error)) {
            return;
        }

        // console.log(JSON.parse(localStorage.getItem('teachersignup1')));
        // handleClickOpen2();


        setIsLoading(true);
        let userRole = "";
        let userRoleSmallLetter = "";

        if (userDetail.role === "Teacher") {
            userRole = "TEACHER"
            userRoleSmallLetter = userRole.toLowerCase();
        } else if (userDetail.role === "Translator") {
            userRole = "TRANSLATOR"
            userRoleSmallLetter = userRole.toLowerCase();
        } else if (userDetail.role === "Researcher") {
            userRole = "RESEARCHER"
            userRoleSmallLetter = userRole.toLowerCase();
        } else if (userDetail.role === "Student") {
            userRole = "STUDENT"
            userRoleSmallLetter = userRole.toLowerCase();
        }

        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();

        const configToken = {
            headers: {
                'Authorization': `Bearer ${logDetails.token}`,
            },
        };

        axios.get(`${web_url}/api/auth/students/${userDetail.email}`, configToken).then((resStudentCheck) => {
            setIsLoading(false)
            setuserDetail({
                email: '',
                role: ''
            });
            console.log('1');

            handleClickOpenError('found');
        }).catch((errStudentC) => {
            if (errStudentC.response.data.message.includes("found")) {
                axios.get(`${web_url}/api/auth/${userRoleSmallLetter}s/${userDetail.email}`, configToken).then((response) => {
                    setIsLoading(false)
                    setuserDetail({
                        email: '',
                        role: ''
                    });
                    console.log('2');
                    handleClickOpenError('found');
                }).catch((err) => {
                    // console.log(err);
                    if (err.response.data.message.includes("found")) {
                        setuserDetail({
                            email: '',
                            role: ''
                        });

                        const filterData = {
                            receiverEmail: userDetail.email,
                            // userRole: userDetail.role.toUpperCase(),
                            invitationStatus: "PENDING"
                        }

                        const filterDataInvCheck = {
                            receiverEmail: userDetail.email,
                            invitationStatus: "ACCEPTED"
                        }

                        const config = {
                            headers: {
                                'Content-Type': 'application/json',
                                "Authorization": `Bearer ${logDetails.token}`,
                            },
                        };

                        axios.post(`${web_url}/api/invitations/admin/filter`, filterDataInvCheck, config).then((resInvS) => {
                            if (resInvS.data.length > 0) {
                                setIsLoading(false);
                                handleClickOpenError("already mail is there")
                                setuserDetail({
                                    email: '',
                                    role: ''
                                });
                            } else {
                                
                                axios.post(`${web_url}/api/invitations/admin/filter`, filterData, config).then((res2) => {
                                    if (res2.data.length > 0) {
                                        setIsLoading(false);
                                        handleClickOpenError("already sent");
                                        setuserDetail({
                                            email: '',
                                            role: ''
                                        });
                                    } else {
                                        const getLogDetails = () => {
                                            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                                        };

                                        const logDetails = getLogDetails();

                                        const newInvitation = {
                                            senderEmail: logDetails.email,
                                            receiverEmail: userDetail.email,
                                            userRole: userRole
                                        }

                                        axios.post(`${web_url}/api/invitations/admin`, newInvitation, config).then((resInv) => {
                                            setOpen(true)
                                            setIsLoading(false);
                                            setuserDetail({
                                                email: '',
                                                role: ''
                                            });
                                        }).catch((errInv) => {
                                            setuserDetail({
                                                email: '',
                                                role: ''
                                            });
                                            setIsLoading(false);
                                            // console.log("e2ew2", errInv.response)
                                            if (errInv.response) {
                                                // console.log(err.response)
                                                if (errInv.response.data.error) {
                                                    handleClickOpenError(errInv.response.data.error);
                                                } else if (errInv.response.data.message) {
                                                    handleClickOpenError(errInv.response.data.message);
                                                } if (errInv.response.data.token) {
                                                    handleClickOpenError(errInv.response.data.token);
                                                } else {
                                                    handleClickOpenError("An unknown error occured");
                                                }

                                            }
                                        })
                                    }
                                    // }).catch((err2) => {
                                    //     // console.log('err2', err);
                                    //     setIsLoading(false);
                                    //     setuserDetail({
                                    //         email: '',
                                    //         role: ''
                                    //     });
                                    //     handleClickOpenError('error occured')
                                    // })
                                    // }
                                }).catch((err2) => {
                                    // console.log('err2', err);
                                    setIsLoading(false);
                                    setuserDetail({
                                        email: '',
                                        role: ''
                                    });
                                    handleClickOpenError('error occured')
                                })
                            }
                        }).catch((errInvS) => {
                            // console.log('err2', err);
                            setIsLoading(false);
                            setuserDetail({
                                email: '',
                                role: ''
                            });
                            handleClickOpenError('error occured')
                        })
                    } else {
                        setIsLoading(false);
                        setuserDetail({
                            email: '',
                            role: ''
                        });
                        handleClickOpenError('error occured')
                    }
                })
            } else {
                setIsLoading(false);
                setuserDetail({
                    email: '',
                    role: ''
                });
                handleClickOpenError('error occured')
            }

        })




    }

    const [open2, setOpen2] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleClickOpen2 = () => {
        setOpen2(true);
    };

    const handleClose2 = () => {
        setOpen2(false);
    };

    const recepientArray = ['Teacher', 'Translator', 'Researcher', 'Student'];


    const fileInputRef = useRef(null);

    const handleButtonClick2 = () => {
        fileInputRef.current.click();
    };


    const handleFileChange2 = (event) => {
        const file = event.target.files[0];

        if (file) {
            setIsLoading(true);

            const reader = new FileReader();
            reader.readAsArrayBuffer(file);

            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: "array" });

                // Get the first sheet
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];

                // Convert sheet to JSON
                const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

                // Validate format
                if (jsonData.length < 2 || jsonData[0][0] !== "email") {
                    handleClickOpenAlert();
                    setIsLoading(false);
                    return;
                }

                // Validate emails
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                const emails = jsonData.slice(1).map(row => row[0]);

                if (emails.some(email => !emailRegex.test(email))) {
                    handleClickOpenAlert();
                    setIsLoading(false);
                    return;
                }

                // If validation passes, proceed with upload
                const getLogDetails = () => {
                    return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                };

                const logDetails = getLogDetails();
                const config = {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "Authorization": `Bearer ${logDetails.token}`
                    },
                };
                const formData = new FormData();
                formData.append("file", file);

                axios.post(`${web_url}/api/invitations/upload`, formData, config)
                    .then((response) => {
                        setIsLoading(false);
                        // if (response.data.message.includes("Some errors occurred")) {
                        //     handleClickOpenError("An error occurred");
                        // } else {

                        // }
                        handleClickOpen1();
                    })
                    .catch((err) => {
                        setIsLoading(false);
                        // console.log("Error upload", err);
                        if (err.response?.data?.message) {
                            handleClickOpenError(err.response.data.message);
                        } else {
                            handleClickOpenError("An error occurred");
                        }
                    });
            };

            reader.onerror = (error) => {
                // console.error("File reading error", error);
                alert("Failed to read the file.");
                setIsLoading(false);
            };
        }
    };

    return (
        <>
            <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} overflow-x-hidden w-screen xl:pt-[20px]`}>
                <div className="pt-[100px] md:pt-[130px] lg:pt-[150px] xl:pt-[0px] w-full">
                    <div className="ml-[30px] md:ml-[60px] lg:ml-[80px] xl:ml-[80px] w-full flex justify-start flex items-center">
                        <MdArrowBack size={25} className="md:hidden" onClick={() => {
                            navigate('/mobile/researcher/dashboard')
                        }} />
                        <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                            navigate('/mobile/researcher/dashboard')
                        }} />
                        <MdArrowBack size={30} className="hidden xl:block" onClick={() => {
                            navigate('/desktop/researcher/dashboard')
                        }} />
                        <p className="text-[20px] md:text-[23px] lg:text-[25px] xl:text-[20px] 2xl:text-[22px] font-bold px-[10px] py-[5px] md:px-[13px] md:py-[8px]">{t('t267')}</p>
                    </div>
                </div>

                <div className="flex justify-center mt-[40px]">
                    <img src="/images/add_student.svg" alt="add students" />
                </div>

                {
                    isLoading ? <div className="items-center justify-center flex pt-[30px]">
                        <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                    </div>
                        :
                        <>

                            <div className="ml-[20px] mr-[20px] md:ml-[100px] md:mr-[100px] lg:ml-[250px] lg:mr-[250px] xl:ml-[400px] xl:mr-[400px] 2xl:ml-[600px] 2xl:mr-[600px] items-center mt-[20px] md:mt-[40px] xl:mt-[10px] flex h-[50px]  md:h-[60px] xl:h-[50px] 2xl:h-[60px] justify-center">
                                <Menu as="div" className="w-full  relative inline-block text-left py-[20px]">
                                    <div>
                                        <MenuButton
                                            className={`truncate pl-[20px] inline-flex w-full justify-left items-center rounded-md bg-[#F1F6FB] h-[50px] md:h-[60px] xl:h-[50px] 2xl:h-[60px] text-[15px] ${userDetail.role === "" ? 'text-gray-500' : 'text-gray-900'} shadow-sm ring-1 ring-inset ring-gray-400 hover:bg-gray-100 pr-[30px]`}
                                        >
                                            <p className="pr-[10px] text-gray-500">{t('t268')}</p>
                                            {userDetail.role === "" ? t('t269') : userDetail.role}
                                            <ChevronDownIcon
                                                aria-hidden="true"
                                                className="absolute right-[10px] size-5 text-gray-700"
                                            />
                                        </MenuButton>
                                    </div>

                                    <MenuItems
                                        transition
                                        className="absolute right-0 z-10 mt-2 w-full origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                                        style={{
                                            width: '100%',
                                            maxHeight: '100px',
                                            overflowY: 'auto'
                                        }}
                                    >
                                        <div className="py-1">
                                            {
                                                recepientArray.map((recepientSelect, index) => (
                                                    <MenuItem key={index}>
                                                        <button
                                                            className="truncate text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                                            onClick={() => {
                                                                setuserDetail((prev) => ({ ...prev, role: recepientSelect }))
                                                            }}
                                                        >
                                                            {recepientSelect}
                                                        </button>
                                                    </MenuItem>
                                                ))
                                            }
                                        </div>
                                    </MenuItems>
                                </Menu>
                            </div>

                            {error.noRole &&
                                <p className='text-[#ff0000] text-[12px] mt-[5px] ml-[20px] mr-[20px] md:ml-[100px] md:mr-[100px] lg:ml-[250px] lg:mr-[250px] xl:ml-[400px] xl:mr-[400px] 2xl:ml-[600px]'>{t('t271')}</p>
                            }

                            <div className="ml-[20px] mr-[20px] md:ml-[100px] md:mr-[100px] lg:ml-[250px] lg:mr-[250px] xl:ml-[400px] xl:mr-[400px] 2xl:ml-[600px] 2xl:mr-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                <MdEmail size="24px" color="#8189B0" />
                                <input type="text" value={userDetail.email} name="email" className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] md:text-[17px] lg:text-[18px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0" placeholder={t('t14')}
                                    onChange={(e) => {
                                        setuserDetail((prev) => ({ ...prev, email: e.target.value.toLowerCase() }))
                                    }}
                                />
                            </div>

                            {error.noEmail &&
                                <p className='ml-[20px] mr-[20px] md:ml-[100px] md:mr-[100px] lg:ml-[250px] lg:mr-[250px] xl:ml-[400px] xl:mr-[400px] 2xl:ml-[600px] 2xl:mr-[600px] text-[#ff0000] text-[12px] mt-[5px]'>{t('t15')}</p>
                            }
                            {error.invalidEmail &&
                                <p className='ml-[20px] mr-[20px] md:ml-[100px] md:mr-[100px] lg:ml-[250px] lg:mr-[250px] xl:ml-[400px] xl:mr-[400px] 2xl:ml-[600px] 2xl:mr-[600px] text-[#ff0000] text-[12px] mt-[5px]'>{t('t16')}</p>
                            }

                            <div className="flex justify-center">
                                <button onClick={handleButtonClick} className="text-[18px] mt-[20px] rounded-lg pt-[10px] pb-[10px] w-[300px] hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E] ">{t('t116')}</button>
                            </div>

                            <div className="hidden xl:flex justify-center pb-[50px] xl:ml-[400px] xl:mr-[400px] 2xl:ml-[600px] 2xl:mr-[600px] xl:mt-[20px] 2xl:mt-[60px]">
                                <div className="mt-[20px] flex justify-center items-center ml-[10px] cursor-pointer" onClick={handleButtonClick2}>
                                    <div className="p-[17px] bg-[#A07B00] rounded-l-lg h-full flex items-center">
                                        <MdSend size={30} color="#FDC50C" />
                                    </div>
                                    <div className="bg-[#FFEBA9] py-[22px] 2xl:py-[20px] pl-[10px] w-full rounded-r-lg h-full flex items-center pr-[10px]">
                                        <p className="overflow-hidden text-ellipsis  text-black text-[13px] 2xl:text-[16px] font-bold">{t('t111')}</p>
                                    </div>
                                    <input
                                        type="file"
                                        ref={fileInputRef}
                                        accept=".xlsx"
                                        onChange={handleFileChange2}
                                        style={{ display: "none" }}
                                    />
                                </div>

                                <div className="mt-[20px] flex justify-center items-center ml-[10px] cursor-pointer pl-[20px]" onClick={() => navigate('/researcher/resend/invitation/select')}>
                                    <div className="p-[17px] bg-[#A07B00] rounded-l-lg h-full flex items-center">
                                        <MdTimer size={30} color="#FDC50C" />
                                    </div>
                                    <div className="bg-[#FFEBA9] py-[22px] 2xl:py-[20px] pl-[10px] w-full rounded-r-lg h-full flex items-center pr-[10px]">
                                        <p className="overflow-hidden text-ellipsis  text-black text-[13px] 2xl:text-[16px] font-bold">{t('t270')}</p>
                                    </div>
                                </div>
                                <div className="mt-[20px] flex justify-center items-center ml-[10px] cursor-pointer px-[20px]" onClick={() => navigate('/researcher/student-requests')}>
                                    <div className="p-[17px] bg-[#A07B00] rounded-l-lg h-full flex items-center">
                                        <MdAddCircle size={30} color="#FDC50C" />
                                    </div>
                                    <div className="bg-[#FFEBA9] py-[22px] 2xl:py-[20px] pl-[10px] w-full rounded-r-lg h-full flex items-center pr-[10px]">
                                        <p className="overflow-hidden text-ellipsis  text-black text-[13px] 2xl:text-[16px] font-bold">{t('t112')}</p>
                                    </div>
                                </div>
                            </div>


                            <div className="xl:hidden flex flex-col mt-[50px] md:mt-[50px] mx-[30px] md:mx-[150px] md:mx-[250px] pb-[120px]" >
                                <div className="flex items-center w-full h-[70px]" onClick={handleButtonClick2}>
                                    <div className="md:hidden bg-[#A07B00] px-[9px] py-[12px] md:p-[15px] rounded-l-lg h-full flex items-center">
                                        <MdSend size={30} color="#FDC50C" />
                                    </div>
                                    <div className="hidden md:flex bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg h-full  items-center">
                                        <MdSend size={23} color="#FDC50C" />
                                    </div>
                                    <div className="bg-[#FFEBA9] py-[15px] md:py-[13px] pl-[10px] w-full rounded-r-lg h-full flex items-center w-full justify-start">
                                        <p className="text-black text-[15px] md:text-[18px]">{t('t111')}</p>
                                    </div>
                                    <input
                                        type="file"
                                        ref={fileInputRef}
                                        accept=".xlsx"
                                        onChange={handleFileChange2}
                                        style={{ display: "none" }}
                                    />
                                </div>
                                <div className="flex items-center w-full mt-[15px] h-[70px]" onClick={() => navigate('/researcher/resend/invitation/select')}>
                                    <div className="md:hidden bg-[#A07B00] px-[9px] py-[12px] md:p-[15px] rounded-l-lg h-full flex items-center">
                                        <MdTimer size={30} color="#FDC50C" />
                                    </div>
                                    <div className="hidden md:flex bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg h-full  items-center">
                                        <MdTimer size={23} color="#FDC50C" />
                                    </div>
                                    <div className="bg-[#FFEBA9] py-[15px] md:py-[13px] pl-[10px] w-full rounded-r-lg h-full flex items-center justify-start">
                                        <p className="text-black text-[15px] md:text-[18px]">{t('t270')}</p>
                                    </div>
                                </div>
                                <div className="flex items-center w-full mt-[15px] h-[70px]" onClick={() => navigate('/researcher/student-requests')}>
                                    <div className="md:hidden bg-[#A07B00] px-[9px] py-[12px] md:p-[15px] rounded-l-lg flex items-center h-full">
                                        <MdAddCircle size={30} color="#FDC50C" />
                                    </div>
                                    <div className="hidden md:flex bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg  items-center h-full">
                                        <MdAddCircle size={23} color="#FDC50C" />
                                    </div>
                                    <div className="bg-[#FFEBA9] py-[15px] md:py-[13px] pl-[10px] w-full rounded-r-lg flex items-center h-full">
                                        <p className="text-black text-[15px] md:text-[18px]">{t('t112')}</p>
                                    </div>
                                </div>
                            </div>

                        </>
                }
            </div>

            <Dialog
                open={open}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogContent className="bg-[#FFF6DA]">
                    {!isLoading &&
                        <DialogContent
                            id="custom-dialog-description"
                            className="text-gray-600 text-md mt-2"
                        >
                            <div className='flex flex-col justify-center items-center text-center'>
                                <img src='/images/success.svg' alt='success' />
                                <div className='mt-[30px] mb-[20px]'>{t('t127_2')}</div>
                                <Button
                                    onClick={handleClose}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t96')}
                                </Button>
                            </div>
                        </DialogContent>
                    }
                </DialogContent>
            </Dialog>

            <Dialog
                open={openError}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleCloseError(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {errorMsg}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2 ">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open1}
                onClose={handleClose1}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        The excel sheet uploaded successfully.
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleClose1}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openAlert}
                onClose={handleCloseAlert}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    Incorrect format
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <p>Please make sure the excel document format is corresponding with the following and try again.</p>
                    <ul style={{ listStyleType: "disc", paddingLeft: "20px" }} className="pt-[20px]">
                        <li>The first column should have a header 'email' with emails below it.</li>
                        <li>Ensure all rows contain valid emails.</li>
                        <li>There should be only one filled column.</li>
                    </ul>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseAlert}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ResearcherInvite;
